import React from 'react';

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

export const Card: React.FC<CardProps> = ({ children, className = '', ...props }) => {
  return (
    <div className={`bg-card-bg backdrop-blur-md border border-card-border rounded-2xl shadow-card overflow-hidden transition-all duration-300 ${className}`} {...props}>
      {children}
    </div>
  );
};

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className = '' }) => {
    return (
        <div className={`p-5 sm:p-6 border-b border-border/40 bg-surface-light/40 ${className}`}>
            {children}
        </div>
    );
};

interface CardTitleProps {
  children: React.ReactNode;
  className?: string;
}

export const CardTitle: React.FC<CardTitleProps> = ({ children, className = '' }) => {
    return (
        <h3 className={`text-xl sm:text-2xl font-bold text-text-main font-heading ${className}`}>
            {children}
        </h3>
    );
};

interface CardContentProps {
  children: React.ReactNode;
  className?: string;
}

export const CardContent: React.FC<CardContentProps> = ({ children, className = '' }) => {
    return (
        <div className={`p-5 sm:p-6 ${className}`}>
            {children}
        </div>
    );
};
